import { CommonModule, DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';

import { TaskModel } from '@core/models/task.model';
import * as fromRoot from '@core/redux/index';
import * as TaskActions from '@core/redux/task/task.actions';
import { Store } from '@ngrx/store';
import { AvatarComponent } from '@ux/components/avatar/avatar.component';

@Component({
  selector: 'app-task-view-archive-popup',
  templateUrl: './task-view-archive-popup.component.html',
  styleUrls: ['./task-view-archive-popup.component.less'],
  imports: [DatePipe, CommonModule, AvatarComponent],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskViewArchivePopupComponent {
  private store = inject<Store<fromRoot.State>>(Store);

  @Output() onClose = new EventEmitter<void>();
  @Input() task: TaskModel;

  onRevert() {
    const newTask = Object.assign(new TaskModel(), this.task, {
      isComplete: false,
      isArchive: false,
    });
    this.store.dispatch(new TaskActions.SaveAction(newTask));
  }

  onArchive() {
    const newTask = Object.assign(new TaskModel(), this.task, {
      isArchive: true,
    });
    this.store.dispatch(new TaskActions.ArchiveAction(newTask));
    this.onClose.emit();
  }
}
